import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private readonly STORAGE_KEY = 'sidebar_expanded';

  private _isExpanded = signal<boolean>(this.getStoredState());

  isExpanded = this._isExpanded.asReadonly();

  private getStoredState(): boolean {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored !== null ? stored === 'true' : true; // Default expanded
  }

  toggle(): void {
    const newState = !this._isExpanded();
    this._isExpanded.set(newState);
    localStorage.setItem(this.STORAGE_KEY, String(newState));
  }

  expand(): void {
    this._isExpanded.set(true);
    localStorage.setItem(this.STORAGE_KEY, 'true');
  }

  collapse(): void {
    this._isExpanded.set(false);
    localStorage.setItem(this.STORAGE_KEY, 'false');
  }
}
